"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findProbabilitiesWithPlayerIdParameter = findProbabilitiesWithPlayerIdParameter;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const getOutcomeKey_1 = require("./getOutcomeKey");
function findProbabilitiesWithPlayerIdParameter(probabilities) {
    const result = {};
    if (probabilities === null) {
        return result;
    }
    for (const market of probabilities.markets) {
        for (const probs of market.probabilities) {
            const playerIdParameter = probs.parameters.find((parameter) => parameter.type === betweb_openapi_axios_1.ParameterType.PlayerId);
            if (playerIdParameter) {
                result[(0, getOutcomeKey_1.getOutcomeKey)(probs)] = playerIdParameter.value;
            }
        }
    }
    return result;
}
//# sourceMappingURL=findProbabilitiesWithPlayerIdParameter.js.map